module.exports = shared.JqueryScrollbar;